'use client';

import { useI18n } from '~/features/i18n';
import { Units } from '.';

export const Unit_RenderEUR: React.FC<{
    unit: 'EUR' | 'CENTS';
    value: number;
}> = props => {
    const i18n = useI18n();

    return Units.formatEUR(props.unit === 'EUR' ? props.value * 100 : props.value, i18n.locale);
};

export const Unit_RenderPercentage: React.FC<{
    value: number;
}> = props => {
    const i18n = useI18n();

    return Units.formatPercentage(props.value / 100, i18n.locale);
};
